/*
	ReactTemplates compatibility shim (WEB-7832).

	window.ReactTemplates is a global aggregator of shared React components/helpers, historically
	created and populated from inside the Angular tree. Its registrars now all live outside it, in
	ui/app/babel/components/LegacyReactTemplates/ (WEB-9930), still pulled into the bundle by
	ui/app/babel/legacy-react.js. ~77 of its keys are read by code outside the Angular tree, so the
	global must survive the Phase 6 deletion of ui/app/upsales/.

	This module owns the global's creation, mirroring the ToolsShim strategy:
	1. installReactTemplatesShim() runs at the React entry, before legacy-react.js loads the
	   Angular tree. It creates the global and its namespaces.
	2. Every writer now lives outside the tree and merges its keys into the existing global
	   instead of replacing it; what remains inside the tree is only Angular directives reading
	   the globals to mount them.
	3. As components move out of the Angular tree (batch by batch, one namespace at a time),
	   this module imports and registers them.
	4. When every key read outside the tree is registered from here, the app no longer depends
	   on the Angular tree for the global.

	Calling install() more than once, or after the Angular tree has already populated the global
	(as in the jest smoketest harness), is safe: existing namespaces and keys are kept.
*/
// The legacy aggregator (WEB-8019): self-creates the global's namespaces and registers ~20
// TOOLS.* helpers at module scope. Evaluating it here (at the React entry) is
// safe — its module scope reads no Tools/window state — and earlier than the old
// legacy-react.js position, which only tree files relied on. It has to stay a side-effect import:
// everything below assumes the global and its namespaces already exist.
// WEB-9232 retired the TOOLS namespace, so install() no longer re-assigns any TOOLS key — every
// consumer imports the helper it needs directly. ui/app/upsales/** still reads ~16 of them off the
// global, and the aggregator's own module-eval registrations above cover those.
import 'App/babel/components/LegacyReactTemplates';
// The row registrations (WEB-8988). These assign into ReactTemplates.ROW, which the
// LegacyReactTemplates aggregator creates at module eval above — so the namespace already exists.
import 'App/babel/components/LegacyReactTemplates/listVisitors';

// Capture the populated namespaces so a re-install after global replacement (the
// mixed-jest-harness case) restores them — the side-effect imports only run once.
const legacyGlobal = (
	window as unknown as {
		ReactTemplates?: {
			ROW?: Record<string, unknown>;
		};
	}
).ReactTemplates;
// install() registers none of these itself, so they need capturing individually (WEB-8988).
const legacyRowKeys: [string, unknown][] = [['visitorRow', legacyGlobal?.ROW?.visitorRow]];

// TOOLS is still listed even though WEB-9232 removed every key registration for it: ui/app/upsales/**
// still reads ~16 TOOLS keys off the global. Creating it here (as well as in the aggregator's module
// eval) keeps a re-install after something replaced the global from leaving the tree with no
// namespace. It goes when Phase 6 deletes the tree. INPUTS was retired in WEB-13321, ROWSTATICS in
// WEB-13401.
const NAMESPACES = ['TOOLS', 'ROW'] as const;

const installReactTemplatesShim = () => {
	// The full ReactTemplates type describes the populated end state; population is incremental
	// by design, so the skeleton is built through an untyped alias.
	const w = window as unknown as { ReactTemplates: Record<string, Record<string, unknown>> };
	w.ReactTemplates = w.ReactTemplates || {};
	for (const ns of NAMESPACES) {
		w.ReactTemplates[ns] = w.ReactTemplates[ns] || {};
	}

	for (const [key, value] of legacyRowKeys) {
		if (value) {
			w.ReactTemplates.ROW[key] = value;
		}
	}
};

export default installReactTemplatesShim;
